import { useSelector } from "react-redux";
import Order from "@/redux/models/Order";

export default function useOrder() {
  const order = useSelector(Order.selectors.getOrder);
  const orderQuantity = order?.items?.reduce((acc, item) => acc + +item.quantity, 0);

  return {
    order,
    orderQuantity,
  };
}
